<div class="video-call-container" [ngClass]="{'active': callState.isActive || callState.isIncoming || callState.isOutgoing}">
  <!-- Incoming call notification -->
  @if (callState.isIncoming && callState.status === 'incoming') {
    <div class="incoming-call-notification">
      <div class="caller-info">
        <h3>Cuộc gọi đến</h3>
        <p>Từ: {{ callState.callerEmail }}</p>
      </div>
      <div class="call-actions">
        <button class="answer-btn" (click)="answerCall()">
          <i class="fas fa-phone"></i> Trả lời
        </button>
        <button class="reject-btn" (click)="rejectCall()">
          <i class="fas fa-phone-slash"></i> Từ chối
        </button>
      </div>
    </div>
  }

  <!-- Outgoing call notification -->
  @if (callState.isOutgoing && callState.status === 'incoming') {
    <div class="outgoing-call-notification">
      <div class="call-info">
        <h3>Đang gọi...</h3>
        <p>Đến: {{ receiverEmail }}</p>
      </div>
      <div class="call-actions">
        <button class="end-call-btn" (click)="endCall()">
          <i class="fas fa-phone-slash"></i> Kết thúc
        </button>
      </div>
    </div>
  }

  <!-- Video call interface -->
  @if (callState.isActive && callState.status === 'accepted') {
    <div class="video-call-interface">
      <!-- Remote video (full screen) -->
      <div class="remote-video-container">
        <video
          #remoteVideo
          autoplay
          playsinline
          class="remote-video">
        </video>
        @if (!remoteStream) {
          <div class="call-status">
            <p>Đang kết nối video...</p>
          </div>
        }
      </div>
      <!-- Local video (picture-in-picture) -->
      <div class="local-video-container" [ngClass]="{'video-off': isVideoOff}">
        <video
          #localVideo
          autoplay
          muted
          playsinline
          [style.transform]="'scaleX(-1)'"
          class="local-video">
        </video>
        @if (isVideoOff) {
          <div class="video-off-indicator">
            <i class="fas fa-video-slash"></i>
          </div>
        }
      </div>
      <!-- Call controls -->
      <div class="call-controls">
        <button class="control-btn" [ngClass]="{'active': isMuted}" (click)="toggleMute()">
          <i class="fas" [ngClass]="isMuted ? 'fa-microphone-slash' : 'fa-microphone'"></i>
        </button>
        <button class="control-btn" [ngClass]="{'active': isVideoOff}" (click)="toggleVideo()">
          <i class="fas" [ngClass]="isVideoOff ? 'fa-video-slash' : 'fa-video'"></i>
        </button>
        <button class="control-btn" (click)="switchCamera()">
          <i class="fas fa-sync"></i>
        </button>
        <button class="end-call-btn" (click)="endCall()">
          <i class="fas fa-phone-slash"></i>
        </button>
      </div>
    </div>
  }
</div>
